import styled from '@emotion/styled'
import { linkStyle } from '../../styles'

export const Submenu = styled.div(
  ({ theme }) => `
    ${linkStyle({ theme })}
    cursor: pointer;
    justify-content: space-between;
    align-items: center;

    &[data-expanded='true'] > img {
      transform: rotate(180deg);
    }
  `
)

export const Arrow = styled.img`
  transform: rotate(0deg);
  transition: transform 0.4s ease-in-out;
`
